import { Vue, setup } from 'vue-class-component';
import { PortalPageType } from '@/types/Auth';
import { Media$Details } from '@/types/Media';
import MediaRepository from '@/repositories/media-repository';
import useSecurityStore from '@/store/security';
import { ApplicationTypes } from '@Ravnur-Inc/shared/types/Application';
import MediaLinkItem from '../media-link-item/media-link-item';

import './media-sharing.scss';

const CN = 'media-sharing';

const repository = new MediaRepository();

class Props {
  origin!: Media$Details;
}

export default class MediaSharing extends Vue.with(Props) {
  private security = setup(() => useSecurityStore());

  get isPublicPortal() {
    return this.security.isPublicApplication;
  }

  get currentApplication() {
    return this.security.currentApplication;
  }

  get isRoot() {
    return this.security.isRootApplication;
  }

  get tenants() {
    let tenants = this.security.tenants;

    if (!this.isRoot) {
      tenants = tenants.filter((t) => t.id === this.security.currentApplication?.id);
    }

    return tenants;
  }

  get sites() {
    return this.origin.sites;
  }

  set sites(value: string[]) {
    this.$emit('refresh', { ...this.origin, sites: value });
    this.save();
  }

  render() {
    return (
      <div class={CN} v-show={this.tenants.length}>
        <l10n class={`${CN}__title`} group="media" tkey="section__sites" />
        {this.tenants?.map((tenant) => {
          const isChecked = this.origin?.sites?.includes(tenant.id) || false;
          const pageType =
            tenant.applicationType === ApplicationTypes.PUBLIC
              ? PortalPageType.PUBLIC
              : PortalPageType.PORTAL;

          return (
            <>
              <checkbox
                key={tenant.id}
                label={tenant.name}
                value={isChecked}
                onInput={() => this.toggleSite(tenant.id)}
              />
              {this.origin && isChecked && (
                <MediaLinkItem
                  withoutLabel
                  application={tenant}
                  media={this.origin}
                  pageType={pageType}
                />
              )}
            </>
          );
        })}
      </div>
    );
  }

  async toggleSite(site: string) {
    const sites = this.sites || [];
    const index = sites.indexOf(site);

    if (index === -1) {
      sites.push(site);
    } else {
      sites.splice(index, 1);
    }

    this.sites = sites;
  }

  async save() {
    try {
      await repository.save(this.origin);
    } catch (e) {
      this.$processException(e);
    }
  }
}
